import {
    ADDUPDATENOTIFICATIONCONFIGPARTNER_SUCCESS,
    ADDUPDATENOTIFICATIONCONFIGPARTNER_FAILED,
    RESET_ADDUPDATENOTIFICATIONCONFIGPARTNER,
    LOADING_ADDUPDATENOTIFICATIONCONFIGPARTNER,
    NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetAddUpdateNotificationConfig = () => {
    return { type: RESET_ADDUPDATENOTIFICATIONCONFIGPARTNER };
};

const partnerAddUpdateNotificationConfigLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDUPDATENOTIFICATIONCONFIGPARTNER });
    await partnerServices
        .post("addUpdateNotificationConfig", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerAddUpdateNotificationConfigsuccess(res.data));
                    break;
                default:
                    dispatch(partnerAddUpdateNotificationConfigFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGPARTNER,
                payload: err
            });
        });
};

function partnerAddUpdateNotificationConfigsuccess(data) {
    return {
        type: ADDUPDATENOTIFICATIONCONFIGPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerAddUpdateNotificationConfigFailed(data) {
    return {
        type: ADDUPDATENOTIFICATIONCONFIGPARTNER_FAILED,
        payload: data,
    };
}

export { resetAddUpdateNotificationConfig, partnerAddUpdateNotificationConfigLists }